import { render, staticRenderFns } from "./QDrilldownAgentDataTable.vue?vue&type=template&id=131ca134&"
import script from "./QDrilldownAgentDataTable.vue?vue&type=script&lang=js&"
export * from "./QDrilldownAgentDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QDrilldownAgentDataTable.vue?vue&type=style&index=0&id=131ca134&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports